import { msg } from 'gt-react';
import { createRoute } from '@tanstack/react-router';
import { Action, Subject } from '@erp/authz';
import { ProductModule } from '@erp/shared-types';
import { GlobeIcon } from '@phosphor-icons/react';
import {
  Route as pathlessAuthenticatedRoute,
  requireAnyPermission,
  requireModules,
} from '../../route';
import { VendorPortalsPage } from './VendorPortalsPage';
import { VendorPortalsSearchSchema } from './vendorPortalsSearch';

export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/pricing/vendor-portals',
  staticData: {
    app: {
      nav: {
        label: msg('Vendor Portals', {
          context: 'sidebar nav label, Pricing section',
        }),
        icon: <GlobeIcon className="h-4 w-4" weight="fill" />,
        group: 'Pricing',
        order: 60,
        groupOrder: 35,
      },
      access: {
        modulesAnyOf: [ProductModule.PRICING],
        permissionsAnyOf: [{ action: Action.Read, subject: Subject.Pricing }],
      },
    },
  },
  component: VendorPortalsRoute,
  // The filters and the page, so a link or a reload shows what the user was looking at.
  validateSearch: VendorPortalsSearchSchema,
  loader: () => ({
    crumb: msg('Vendor Portals', { context: 'page breadcrumb' }),
  }),
  beforeLoad: async ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.PRICING],
    });
    // `access` above only decides what the sidebar shows; direct navigation needs its
    // own guard (see the PCSC Masterlist route).
    await requireAnyPermission({
      context,
      permissions: [{ action: Action.Read, subject: Subject.Pricing }],
    });
  },
});

function VendorPortalsRoute() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <VendorPortalsPage
      search={search}
      onSearchChange={(next, options) =>
        void navigate({ search: next, replace: options?.replace })
      }
    />
  );
}
